import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * A "line" is the hardcoded product line the customer picks on the first screen
 * (PCA / SPARKE / TERRACE / MINIMAL). The choice filters which final products
 * are shown and is persisted so a page refresh keeps it.
 */
@Injectable({ providedIn: 'root' })
export class LineSelectionService {
  /** Keep in sync with LinesComponent.lines. */
  static readonly KNOWN_LINES = ['PCA', 'SPARKE', 'TERRACE', 'MINIMAL'];

  private readonly storageKey = 'selectedLine';
  private _selectedLine = new BehaviorSubject<string | null>(this.readStored());

  get selectedLine$(): Observable<string | null> {
    return this._selectedLine.asObservable();
  }

  get selectedLine(): string | null {
    return this._selectedLine.value;
  }

  setLine(line: string): void {
    localStorage.setItem(this.storageKey, line);
    this._selectedLine.next(line);
  }

  clear(): void {
    localStorage.removeItem(this.storageKey);
    this._selectedLine.next(null);
  }

  private readStored(): string | null {
    const stored = localStorage.getItem(this.storageKey);
    // A line that has since been removed (e.g. PREMIUM) would otherwise strand
    // the user on a product list filtered to a line that no longer exists.
    if (stored && !LineSelectionService.KNOWN_LINES.includes(stored)) {
      localStorage.removeItem(this.storageKey);
      return null;
    }
    return stored;
  }
}
